import newsletter from './newsletter.js';
import hero from './hero.js';
import socialShare from './socialShare.js';
import whoWeAre from './whoWeAre.js';
import writeToMPAction from './writeToMPAction.js';
import writeToLord from './writeToLord.js';
import writeToMSPs from './writeToMSPs.js';
import listOfTalks from './listOfTalks.js';
import listOfEvents from './listOfEvents.js';
import talk from './talk.js';

import './donate/index.js';

window.newsletter = newsletter;
window.hero = hero;
window.talk = talk;
window.socialShare = socialShare;
window.whoWeAre = whoWeAre;
window.writeToMPAction = writeToMPAction;
window.writeToLord = writeToLord;
window.writeToMSPs = writeToMSPs;
window.listOfTalks = listOfTalks;
window.listOfEvents = listOfEvents;
